import { TInputEmailProps } from "./index";
import { Input } from "../../core/Input";

export default function InputEmail({
  register,
  required,
  error,
  style,
  label,
  nameInput,
  onChange,
  readOnly,
}: TInputEmailProps) {
  //const nameInput = "email"
  return (
    <Input
      type="Temail"
      label={label}
      fieldName={nameInput}
      register={register}
      required={required}
      error={error[nameInput]}
      style={style}
      onChange={onChange}
      readOnly={readOnly}
    />
  );
}
